import { useEffect } from 'react'
import { MapContainer, TileLayer, GeoJSON, Marker, Popup, useMap } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

// Fix default marker icon
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
})

const MAPTILER_KEY = import.meta.env.VITE_MAPTILER_KEY
const MAPTILER_STREETS = `https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${MAPTILER_KEY}`
const MAPTILER_SATELLITE = `https://api.maptiler.com/maps/satellite/256/{z}/{x}/{y}.jpg?key=${MAPTILER_KEY}`
const MAPTILER_ATTRIBUTION = '&copy; <a href="https://www.maptiler.com/">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/">OSM</a>'

const PARCELLE_STYLE = {
  fillColor: '#3b82f6',
  fillOpacity: 0.25,
  color: '#1d4ed8',
  weight: 2.5,
}

function RecenterMap({ latitude, longitude }) {
  const map = useMap()
  useEffect(() => {
    map.invalidateSize()
    map.setView([latitude, longitude])
  }, [map, latitude, longitude])
  return null
}

function StaticMap({ latitude, longitude, zoom, height, tileUrl, parcelleGeometry }) {
  const geojsonKey = parcelleGeometry ? JSON.stringify(parcelleGeometry).slice(0, 40) : 'none'

  return (
    <MapContainer
      center={[latitude, longitude]}
      zoom={zoom}
      style={{ height, width: '100%' }}
      className="rounded-lg z-0"
      dragging={false}
      zoomControl={false}
      scrollWheelZoom={false}
      doubleClickZoom={false}
      touchZoom={false}
      boxZoom={false}
      keyboard={false}
    >
      <TileLayer
        url={tileUrl}
        tileSize={256}
        attribution={MAPTILER_ATTRIBUTION}
      />
      <RecenterMap latitude={latitude} longitude={longitude} />
      {parcelleGeometry && (
        <GeoJSON
          key={geojsonKey}
          data={{ type: 'Feature', geometry: parcelleGeometry, properties: {} }}
          style={PARCELLE_STYLE}
        />
      )}
      <Marker position={[latitude, longitude]}>
        <Popup>Bien expertise</Popup>
      </Marker>
    </MapContainer>
  )
}

export default function MapTilerStatic({ latitude, longitude, parcelleGeometry }) {
  if (!latitude || !longitude || !MAPTILER_KEY) return null

  const geoHash = parcelleGeometry ? JSON.stringify(parcelleGeometry).length : 0
  const mapKey = `${latitude.toFixed(6)},${longitude.toFixed(6)},${geoHash}`

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <p className="text-xs text-slate-500 mb-1">Situation generale</p>
        <StaticMap
          key={`gen-${mapKey}`}
          latitude={latitude}
          longitude={longitude}
          zoom={8}
          height="375px"
          tileUrl={MAPTILER_STREETS}
        />
      </div>
      <div>
        <p className="text-xs text-slate-500 mb-1">Situation detaillee</p>
        <StaticMap
          key={`det-${mapKey}`}
          latitude={latitude}
          longitude={longitude}
          zoom={18}
          height="375px"
          tileUrl={MAPTILER_SATELLITE}
          parcelleGeometry={parcelleGeometry}
        />
      </div>
    </div>
  )
}
